import { Transaction } from './../model/Transaction';
import { forkJoin } from 'rxjs';
import { AuthService } from './../auth/guards/auth-service.service';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ConfirmationService, MessageService } from 'primeng/api';
import { ApiService } from '../services/api-service/apiService/api.service';
import { TransactionPendient } from '../model/TransactionPendient';
import { FIELDS_TABLE_TRANSACTION_PENDIENT } from '../model/mocks/mock-fieldsTableTransactionPendient';
import { NumberFormatService } from '../services/numberFormat/number-format-service.service';

@Component({
  selector: 'app-show-transactions-pendient',
  templateUrl: './show-transactions-pendient.component.html',
  styleUrls: ['./show-transactions-pendient.component.css'],
  providers: [ConfirmationService, MessageService],
  changeDetection: ChangeDetectionStrategy.OnPush
})

export class ShowTransactionsPendientComponent implements OnInit {

  displayEditModal: boolean = false;
  selectedTransaction: any = {};

  transactionsPendients!: TransactionPendient[];
  fieldsTableTransactionsPendients = FIELDS_TABLE_TRANSACTION_PENDIENT;

  newPoint!: any;
  userID: number;
  pointByUserID: any;
  displayDelete: any;
  canEdit: any;
  user: any;
  role: any;

  transactionTypes: any[] = [];
  pairs: any[] = [];
  clients: any[] = [];
  transactionPairs: any[] = [];

  constructor(private confirmationService: ConfirmationService,
    private messageService: MessageService,
    private router: Router,
    private cdr: ChangeDetectorRef,
    private apiService: ApiService,
    private authService: AuthService,
    private numberFormatService: NumberFormatService) {
    this.userID = parseInt(this.authService.userId);
    this.user = this.authService.getCurrentUser();
    this.role = this.authService.userRole;
    if (this.user && this.user.permissions && this.user.permissions['transacciones']) {
      this.canEdit = this.user.permissions['transacciones'].includes('ver pendientes_editar') || this.role == 'Administrador';
    }
  }

  ngOnInit(): void {
    this.loadAllData();
    this.getPoints();
  }

  loadAllData() {
    forkJoin([
      this.apiService.get(ApiService.apiURLBack + 'transaccionespendiente'),
      this.apiService.get(ApiService.apiURLBack + 'tipoTransaccion'),
      this.apiService.get(ApiService.apiURLBack + 'cliente'),
      this.apiService.get(ApiService.apiURLBack + 'par')
    ]).subscribe({
      next: ([pendientes, tipos, clientes, pares]) => {
        this.transactionsPendients = pendientes;
        this.transactionTypes = tipos;
        this.clients = clientes;
        this.pairs = pares;
        this.transactionPairs = pares.map((p: any) => ({
          id: `${p.id}`,
          name: `${p.name}`
        }));

        this.cdr.detectChanges();
      },
      error: (error: any) => {
        this.messageService.add({
          severity: 'error',
          summary: error.message || 'Error al cargar datos',
          life: 2000,
        });
      }
    });
  }

  getPoints() {
    this.apiService.get(ApiService.apiURLBack + 'punto').subscribe({
      next: (response: any) => {
        this.pointByUserID = response.find(
          (item: { user: { id: any } }) => item.user.id === this.userID
        ).id;
        if (!this.pointByUserID) {
          this.pointByUserID = 1;
        }
        this.addPoint();
        this.cdr.detectChanges();
      },
      error: (error: { message: any }) => {
        this.messageService.add({
          severity: 'error',
          summary: error.message,
          life: 2000,
        });
      },
    });
  }

  addPoint() {
    this.newPoint = {
      point_of_sell_id: 1,
    };
  }

  finalyTransaction(transactionPendient: any) {
    this.newPoint.point_of_sell_id = this.pointByUserID;
    this.apiService
      .postTransactionPendient(ApiService.apiURLBack + 'transaccionpendiente', transactionPendient.id, this.newPoint)
      .subscribe({
        next: () => {
          this.messageService.add({
            severity: 'success',
            summary: 'Transacción finalizada exitosamente',
            life: 2000,
          });
          this.loadAllData();
          this.cdr.detectChanges();
        },
        error: (error: { message: any }) => {
          this.messageService.add({
            severity: 'error',
            summary: error.message,
            sticky: true,  // Hace que el mensaje sea persistente
          });
        },
      });
  }
  deletetransaction(transactionPendient: any) {
    this.displayDelete = true;
    this.cdr.detectChanges();
    this.confirmationService.confirm({
      message: 'Deseas eliminar esta transacción?',
      header: 'Confirmar operación',
      icon: 'pi pi-info-circle',
      accept: () => {
        const index = this.transactionsPendients.findIndex(transaction => transaction.id === transactionPendient.id);
        if (index !== -1) {
          this.transactionsPendients.splice(index, 1);
          this.cdr.detectChanges();
          this.apiService
            .delete(ApiService.apiURLBack + 'transaccion', transactionPendient.id)
            .subscribe(
              () => {
                this.messageService.add({
                  severity: 'info',
                  summary: 'Confirmado',
                  detail: 'Registro eliminado',
                });
                this.loadAllData();
              },
              () => {
                this.messageService.add({
                  severity: 'error',
                  summary: 'Error',
                  detail: 'Error al eliminar el registro',
                });
              }
            );
        } else {
          this.messageService.add({
            severity: 'warn',
            summary: 'Transacción no encontrada',
            detail: 'No se encontró la transacción a eliminar',
          });
        }
      },
    });
  }

  updateTransaction(transaction: any) {

    const updatedData = {
      type_transaction_id: transaction.type_transaction.id,
      pair_id: transaction.pair.id,
      quantity: transaction.quantity,
      price: transaction.price,
      point_of_sell_id: this.pointByUserID,
      customer_id: transaction.customer.id,
      user_id: this.userID,
    };

    this.apiService.put(ApiService.apiURLBack + `transaccionpendiente`, transaction.id, updatedData)
      .subscribe({
        next: () => {
          this.messageService.add({
            severity: 'success',
            summary: 'Transacción actualizada',
            life: 2000,
          });

          this.loadAllData();

          this.displayEditModal = false;
          this.cdr.detectChanges();
        },
        error: (error: any) => {
          const msg = error.error?.Error || error.message;
          this.messageService.add({
            severity: 'error',
            summary: 'Error al actualizar',
            detail: msg,
            sticky: true,
          });
        }
      });
  }

  openEditModal(transaction: any) {
    if (!this.transactionTypes.length || !this.clients.length || !this.transactionPairs.length) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Aguarde un momento..',
        // detail: 'Espere a que se carguen los datos antes de editar',
      });
      return;
    }

    this.selectedTransaction = { ...transaction };

    this.selectedTransaction.type_transaction = this.transactionTypes.find(
      t => t.id === transaction.type_transaction.id
    );

    this.selectedTransaction.customer = this.clients.find(
      c => c.id === transaction.customer.id
    );

    this.selectedTransaction.pair = this.transactionPairs.find(
      p => p.id == transaction.pair.id
    );

    this.displayEditModal = true;
  }

  closeEditModal() {
    this.displayEditModal = false;
  }

  saveTransaction() {
    this.updateTransaction(this.selectedTransaction);
    this.closeEditModal();
  }

  formatNumber(value: number): string {
    return this.numberFormatService.formatNumber(value);
  }
}
